import { WretchError } from 'wretch/resolver'
import { toast } from 'sonner'
import { useTranslations } from 'i11n'

export const useApiError = () => {
  const t = useTranslations()

  const handleError = (error: WretchError) => {
    const code = error.json?.code || 'unexpected_error'

    switch (code) {
      case 'invitation_already_exists':
        return toast('Invitación duplicada', {
          description: `Ya existe una invitación para ${error.json.conflict_value}`,
        })

      case 'invitation_user_already_exists':
        return toast('Invitación duplicada', {
          description: `Ya existe el usuario ${error.json.conflict_value} en la plataforma`,
        })

      default:
        return toast(t(`errors.${code}.title`, error.json?.metadata || {}), {
          description: t(
            `errors.${code}.description`,
            error.json?.metadata || {}
          ),
        })
    }
  }

  return {
    handleError,
  }
}
